const ACCESS_TOKEN_KEY = 'maxus_access_token'
const REFRESH_TOKEN_KEY = 'maxus_refresh_token'

export interface AuthTokenPair {
  access_token: string
  refresh_token: string
  token_type: string
  expires_in: number
  refresh_token_expires_in: number
}

export interface TokenPayload {
  sub: string
  personId: string
  loginIdentityId: string
  bizUserId: string
  token_kind: 'access' | 'refresh'
  iat: number
  exp: number
  jti: string
}

export const decodeTokenPayload = (token: string): TokenPayload | null => {
  try {
    const base64 = token.split('.')[1]
    if (!base64) return null
    const json = atob(
      base64
        .replace(/-/g, '+')
        .replace(/_/g, '/'),
    )
    return JSON.parse(json) as TokenPayload
  } catch {
    return null
  }
}

export const getAccessToken = (): string | null => {
  try {
    return localStorage.getItem(ACCESS_TOKEN_KEY)
  } catch {
    return null
  }
}

export const getRefreshToken = (): string | null => {
  try {
    return localStorage.getItem(REFRESH_TOKEN_KEY)
  } catch {
    return null
  }
}

export const setTokens = (pair: AuthTokenPair): void => {
  try {
    localStorage.setItem(ACCESS_TOKEN_KEY, pair.access_token)
    localStorage.setItem(REFRESH_TOKEN_KEY, pair.refresh_token)
  } catch {
    // localStorage 不可用（隐私浏览、存储已满等）。
  }
}

// 仅更新 access token：/auth/refresh 只签发新 access token，不轮换 refresh token。
export const setAccessToken = (accessToken: string): void => {
  try {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken)
  } catch {
    // localStorage 不可用。
  }
}

export const clearTokens = (): void => {
  try {
    localStorage.removeItem(ACCESS_TOKEN_KEY)
    localStorage.removeItem(REFRESH_TOKEN_KEY)
  } catch {
    // localStorage 不可用。
  }
}
